import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const promos = [
  '✨ Free Shipping on Orders $150+ ✨',
  '🌿 New Boho Styles Added Daily — Shop the Latest',
  '💛 Join the Boho Fam — Get Early Access to New Drops',
  '🌸 Curated Bohemian Fashion — Tops, Dresses, Jewelry & More',
];

const PromoTicker = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % promos.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="relative bg-berry text-berry-foreground py-2 px-4 text-center text-sm font-medium tracking-wide overflow-hidden">
      <div
        key={currentIndex}
        className="animate-fade-in"
      >
        {promos[currentIndex]}
      </div>
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-berry-foreground/60 hover:text-berry-foreground transition-colors"
        aria-label="Close promotions"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default PromoTicker;
